import {
    Box,
    CrudMode,
    DataDisplay,
    Grid,
    pn,
    Stack,
    Typography,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { ProviderPosition, ProviderPositionEditResource, ProviderPositionViewResource } from "generated/openApi";
import produce from "immer";
import React from "react";

export const ProviderPositionPageBody = (props: {
    crudMode: CrudMode;
    providerPosition: ProviderPosition;
    setProviderPosition: (value: ProviderPosition) => void;
    viewResource: ProviderPositionViewResource;
    editResource: ProviderPositionEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<ProviderPosition>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.providerPosition.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.providerPosition.name}
                onChange={(e) =>
                    props.setProviderPosition(
                        produce(props.providerPosition, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};